function setSessionStorageItem(key: string, value: Record<string, unknown>) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore storage errors
  }
}

export default setSessionStorageItem;
